export default class FilterListTruncate {
  constructor(el, { context }) {
    this.el = el;
    this.context = context;
    this.controller = new AbortController();

    const toggles = this.el.querySelectorAll('[data-filter-list-toggle]');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', e => this._toggle(e), { signal: this.controller.signal });
    });
  }

  _toggle(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const isExpanded = trigger.dataset.filterListToggle === 'true';
    const list = trigger.closest('.collection-filters__filter-list-toggle-wrapper').previousElementSibling;

    list.querySelectorAll('[data-hidden-default]').forEach(item => {
      item.classList.toggle('collection-filters__filter-list-item--hidden', isExpanded);
    });

    trigger.dataset.filterListToggle = String(!isExpanded);
    trigger.textContent = isExpanded ? this.context.see_more : this.context.see_less;
  }

  unload() {
    this.controller.abort();
  }
}
